import { Component, resource, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { IBbitWebShopListDocument } from '@bbitgmbh/bbit.utils';
import { BbitWebShopApiService, BbitWebShopFormatPricePipe } from '@bbitgmbh/webshop.sdk';
import { I18nPipe, LuxonPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { LoadingComponent } from '../../helper/loading/loading.component';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  imports: [RouterLink, NgIcon, I18nPipe, LuxonPipe, BbitWebShopFormatPricePipe, LoadingComponent],
})
export class DocumentsComponent {
  public bucket = signal('');
  public documents = resource<IBbitWebShopListDocument[], { _bucket: string }>({
    params: () => {
      return { _bucket: this.bucket() };
    },
    loader: async ({ params }) => {
      if (!params._bucket) {
        throw new Error('Bucket is missing');
      }
      return await this.api.getDocuments(params._bucket);
    },
  });

  constructor(
    public api: BbitWebShopApiService,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._activatedRoute.params.pipe(takeUntilDestroyed()).subscribe(async (params) => {
      this.bucket.set(params['_bucket']);
    });
  }
}
